import { defineComponent, h, PropType } from 'vue';
import { coming_soon } from '@components/icons';
import { State } from '../../state';
import BarButton from '@components/bar-button';
import { hide_sketches, number_of_non_deleted_reference_sketches, show_sketches } from '../../reference_sketches';
import show_sketches_svg from '../../../assets/img/SVG_icons/Top/four_sketch/show_sketches.svg';
import { img } from '@phi/components';
import ShowSketchesTooltip from './ShowSketchesTooltip';

export const ShowSketchesIcon = show_sketches_svg;

export default defineComponent({
    props: {
        state: {
            required: true,
            type: Object as PropType<State>,
        },
    },

    computed: {
        coming_soon() {
            return !this.state.loaded;
        },

        alt() {
            return 'Show/hide reference sketches';
        },

        disabled() {
            return !this.state.loaded
                || number_of_non_deleted_reference_sketches() === 0
                || this.state.editing_reference_sketches;
        },
    },

    watch: {
        disabled(value: boolean) {
            this.$emit('update:disabled', value);
        },
    },

    emits: {
        'update:disabled': (x: boolean) => true,
    },

    methods: {
        onClick() {
            if (this.disabled)
                return;
            else if (this.state.showing_reference_sketches)
                hide_sketches();
            else
                show_sketches();
        }
    },

    render() {
        return h(BarButton, {
            id: 'show-sketches-button',
            tippy: 'top',
            onClick: this.onClick,
            disabled: this.disabled,
            selected: this.state.tut_stage === 13,
            active: this.state.showing_reference_sketches,
        }, {
            icon: () => this.coming_soon ? coming_soon(this.alt) : img(show_sketches_svg, this.alt),
            tooltip: ShowSketchesTooltip,
        });
    },
});
